module.exports = __webpack_public_path__ + "static/img/admin(7).d0eaf39a.png";